const PSEvents = require('PSEvents');
const GenericEngine = require('GenericEngine');
const BuyFeaturePopupItem = require('BuyFeaturePopupItem');

const SlotUI = require('SlotUI');
const PSState = require('PSState');

cc.Class({
    extends: cc.Component,

    properties: {
        popupNode: cc.Node,
        buyFeatureItems: [BuyFeaturePopupItem],
        container: cc.Node,
    },

    ctor () {
        if (SlotUI.isReplayMode()) {
            this.locked = true;
        } else {
            this.locked = false;
        }
    },

    onLoad () {
        PSEvents.onEngineInitialized((data) => this.init(data));

        this.betChangeListener = (state) => this.updateBet(state);
        this.spinRequestListener = () => this.close();
        this.menuOpened = () => this.close();
        this.buyButtonClicked = () => this.open();

        PSEvents.subscribe(PSEvents.STATE_UPDATED, this.betChangeListener);
        PSEvents.subscribe(PSEvents.SPIN_REQUEST, this.spinRequestListener);
        PSEvents.subscribe(PSEvents.MENU_OPENED, this.menuOpened);
        PSEvents.subscribe(PSEvents.BUY_BUTTON, this.buyButtonClicked);
    },

    onDestroy () {
        PSEvents.unsubscribe(PSEvents.STATE_UPDATED, this.betChangeListener);
        PSEvents.unsubscribe(PSEvents.SPIN_REQUEST, this.spinRequestListener);
        PSEvents.unsubscribe(PSEvents.MENU_OPENED, this.menuOpened);
        PSEvents.unsubscribe(PSEvents.BUY_BUTTON, this.buyButtonClicked);
    },

    open () {
        this.popupNode.active = true;
        this.updateBet(PSState.get());
    },

    close () {
        this.popupNode.active = false;
    },

    init(data) {
        this.initialized = true;

        this.purchases = GenericEngine.getPurchases();

        const l = Math.max(this.purchases.length, this.buyFeatureItems.length);

        for (let i = 0; i < l; i++) {
            if (this.purchases.length < i) {
                cc.warn('there are less buy features than expected');
                this.buyFeatureItems[i].node.destroy();
                break;
            }

            if (this.buyFeatureItems.length < i) {
                cc.warn('there are more buy features than expected');
                break;
            }

            const buyFeatureItem = this.buyFeatureItems[i];

            const purhcaseData = this.purchases.find(p => p.feature === buyFeatureItem.featureId);

            if (!purhcaseData) {
                cc.error(`purchase data with ID = [${buyFeatureItem.featureId}] has not found`);
                this.initialized = false;
                return;
            }
            this.buyFeatureItems[i].init(purhcaseData);
        }

        this.updateBet(data);
    },

    updateBet ({ betAmount, balance }) {
        if (this.betAmount !== betAmount || this.balance !== balance) {
            this.betAmount = betAmount;
            this.balance = balance;
            this.buyFeatureItems.forEach(item => item.updateBet(betAmount, balance));
        }
    },

    lockButton () {
        this.locked = true;
        if (this.initialized) {
            this.buyFeatureItems.forEach(item => item.lockButton());
        }
    },

    unlockButton () {
        this.locked = false;
        if (this.initialized) {
            this.buyFeatureItems.forEach(item => item.lockButton());
        }
    },
});
